/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import Section from '../components/Section'

function Template() {
	return (
		<div className='main-container'>
			<Section className='height-auto'>
				<div className='container'>
					<div className='row justify-content-center'>
						<div className='col-sm-8 col-md-7 text-center'>
							<h2>Sell With Us</h2>
						</div>
					</div>
				</div>
			</Section>

			<Section id='sell-with-us__section'>
				<div className='col-12 col-md-10 offset-md-1 offset-0'>
					<p>
						The Etho™ is an e-commerce marketplace that connects
						producers and sellers of ethically made products to
						consumers around the globe. The Etho offers sellers the
						e-commerce services they require to sell their goods in
						The Etho’s online marketplace. The Etho’s sellers have
						access to our unique sales platform and our
						international, and growing, audience of online shoppers.
						We also offer our sellers a list of other services,
						including:
					</p>
					<ul>
						<li>
							<p>
								Verification through The Etho on Ethical
								Principles
							</p>
						</li>
						<li>
							<p>
								Payment Processing<sup>1</sup>
							</p>
						</li>
						<li>
							<p>
								Shipping Support<sup>2</sup>
							</p>
						</li>
						<li>
							<p>
								Impact Calculator<sup>3</sup>
							</p>
						</li>
						<li>
							<p>
								Customer Support<sup>4</sup>
							</p>
						</li>
						<li>
							<p>
								Tech support related to your products on The
								Etho Marketplace<sup>5</sup>
							</p>
						</li>
						<li>
							<p>
								And more! Let us know what you're looking for
								and we will try to work with you. We are eager
								to help you grow your business!
								<sup>6</sup>
							</p>
						</li>
					</ul>
					<div id='usp-items' className='row'>
						<div className='usp-item text-center'>
							<img
								src='https://placehold.it/150'
								alt='placeholder'
							/>
							<p>
								We find the best ethical brands from around the
								world.
							</p>
						</div>
						<div className='usp-item text-center'>
							<img
								src='https://placehold.it/150'
								alt='placeholder'
							/>
							<p>
								We do pre-checks, questionnaires, or site visits
								to ensure that sellers meet our ethical
								standards.
							</p>
						</div>
						<div className='usp-item text-center'>
							<img
								src='https://placehold.it/150'
								alt='placeholder'
							/>
							<p>
								Our handpicked sellers list their shops and
								products on The Etho.
							</p>
						</div>
						<div className='usp-item text-center'>
							<img
								src='https://placehold.it/150'
								alt='placeholder'
							/>
							<p>
								Shop from a variety of products and sellers with
								a single cart secure checkout.
							</p>
						</div>
						<div className='usp-item text-center'>
							<img
								src='https://placehold.it/150'
								alt='placeholder'
							/>
							<p>
								Your purposeful orders are shipped directly from
								our artisans to your doorstep.
							</p>
						</div>
					</div>
					<p>
						The Etho™ handles every stage of your product’s sale
						from cross-platform marketing to our secure payment
						processing platform to shipping support. We are with you
						every step of the way. With our current and growing list
						of business services, selling your brand line through
						The Etho™ is as smooth and seamless a process as
						possible.
					</p>
					<p>
						The process for selling products through The Etho
						involves a necessary verification of your company’s
						ethical principles. Because we are an ethical
						marketplace we take our time to ensure that all products
						sold on The Etho™ meet a certain base level of ethical
						business behavior. This includes paying employees a
						livable wage, providing them safe working conditions and
						meeting a level of environmental sustainability.
					</p>
					<p className='text-center'>
						To become a The Etho™ seller, please contact us at&nbsp;
						<a href='mailto:info@theetho.com '>info@theetho.com</a>
					</p>
					<ol>
						<li>
							<p>
								Payment processing is offered through paypal or
								through paying with a credit card on our secure
								online shop. The Etho™ manages all payments and
								releases 85% of the sale price to the seller
								once the purchased items have been shipped.
							</p>
						</li>
						<li>
							<p>
								Shipping and logistics support through Easypost.
								Easypost provides the tracking numbers,
								discounted shipping options and all of the
								back-end technology necessary to manage
								international shipping.
							</p>
						</li>
						<li>
							<p>
								Impact calculator is offered through our
								partnership with Greenstory.ca, the calculator
								measures sellers positive impact through easy to
								understand metrics. This helps sellers to
								improve their internal processes to optimize
								their impact.
							</p>
						</li>
						<li>
							<p>
								The Etho provides full-service customer service
								support so that you don’t have to! We work with
								both the sellers and the customers to resolve
								any issues that may arise from selling through
								The Etho™.
							</p>
						</li>
						<li>
							<p>
								The Etho also offers basic back-end technology
								support to our sellers. We help with a variety
								of things such as product upload assistance to
								order processing and management support through
								our system.
							</p>
						</li>
						<li>
							<p>
								Finally we are working hard to develop more
								software services for our sellers such as
								inventory tracking and so much more. Please let
								us know if you would like to have anything in
								particular – we work for your success!
							</p>
						</li>
					</ol>
					<h3 className=''>Associated Fees</h3>
					<table id='associated-fees__table'>
						<thead>
							<tr>
								<th>Verification Fees</th>
								<th>Payment Processing</th>
								<th>Shipping Support</th>
								<th>Impact Calculator</th>
								<th>Customer Support</th>
								<th>Tech Support</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<th>
									$100 initial verification fee $50 annual
									renewal fee
								</th>
								<th>1.5% of total order price</th>
								<th>
									Depends on volume shipped - contact us for
									further information
								</th>
								<th>
									Green Story charges a set fee for analysis,
									that is determined individually for each
									seller (starting at $500)
								</th>
								<th>Free</th>
								<th>
									Included in The Etho™'s sales package (15%
									of sales price)
								</th>
							</tr>
						</tbody>
					</table>
				</div>
			</Section>
		</div>
	)
}

export default Template
